enum ClaimJobPaymentStatusTriggers {
  CLAIMS_REMITTANCE_ADVICE = 'CLAIMS_REMITTANCE_ADVICE',
}
export default ClaimJobPaymentStatusTriggers;

export type VerifyClaimStatusCode = Utils.VerifyExtends<
  Model.Enum.ClaimJobPaymentStatusTriggers,
  Utils.ValueOf<typeof ClaimJobPaymentStatusTriggers>
>;
